



import React from "react";
import { BrowserRouter, Switch, Redirect, Route, Link, NavLink } from "react-router-dom";

import { Header } from '../../Components/Layout/Header.jsx'
import { GameDetails } from '../../Components/Game/GameDetails.jsx'
import { ObavijestiPoker } from '../../Components/Layout/ObavijestiPoker.jsx'
import { Game } from '../../Components/Game/Game.jsx'

import { Banners } from '../../Components/Banner/Banners.jsx'
import { MojCasino } from '../../Components/Casino/MojCasino.jsx'
import { BonusItem } from '../../Components/Bonuses/BonusItem.jsx'
import { MaratonPobjednici } from '../../Components/Casino/MaratonPobjednici.jsx'


import { BonusiHorizontalItems } from '../../Components/Poker/HomePage/BonusiHorizontalItems.jsx'
import { IzdvojeniTurniriHorizontalItems } from '../../Components/Poker/HomePage/IzdvojeniTurniriHorizontalItems.jsx'
import { PokerTurnirPobjednici } from '../../Components/Poker/PokerTurnirPobjednici.jsx'


export class PokerTournaments extends React.Component {

    constructor(props) {
        super(props);
        this.state = { turniri: null };


        this.setData = this.setData.bind(this);
        this.getBackHeaderText = this.getBackHeaderText.bind(this);
        this.renderSideNavigationItem = this.renderSideNavigationItem.bind(this);
        this.renderTurnirDetails = this.renderTurnirDetails.bind(this);
        this.renderTurniri = this.renderTurniri.bind(this);
        casino.utils.createPageGoogleTagManagerEvent('Turniri', 'Svi turniri', 'poker', this.props.user);
    }

    componentDidMount() {
        window.scrollTo(0, 0);

        this.props.showMenuFn(false);
        this.props.showLoadingFn(true);

        var promises = Promise.all([casino.repos.pokerTurniriRepo.list()]);

        this.dataPromises = casino.utils.makeCancelablePromise(promises);
        this.dataPromises.promise.then(this.setData, function (reason) { });
    }

    componentWillUnmount() {
        this.dataPromises.cancel();
        this.props.showLoadingFn(false);
    }

    setData(data) {
        var [turniri] = data;
        this.setState({
            turniri: turniri
        });
        this.props.showLoadingFn(false);
    }

    getBackHeaderText(route) {
        if (this.state && this.state.turniri) {
            var sifra = route.match.params.turnir || '';
            var action = route.match.params.action || 'info';
            return this.state.turniri.filter(x => x.sifra == sifra)[0].naziv + ' - ' + (action == 'info' ? 'Informacije' : 'Rezultati');
        }
    }

    renderSideNavigationItem(turnir) {
        var pathName = this.props.route.match.url;
        return <NavLink key={turnir.sifra} activeClassName="selected" className="sidebar-menu--link"
            to={(pathName + '/' + turnir.sifra).split('//').join('/')}><span>{turnir.naziv}</span></NavLink>
    }

    renderTurnirDetails(route) {

        // moramo na plafon
        window.scrollTo(0, 0);


        if (!this.state.turniri)
            return (<div className='min-height-50 padding-sides-medium-2'><br />Dohvaćanje turnira...</div>);

        var sifra = route.match.params.turnir;
        var action = route.match.params.action || 'info';
        var turnir = this.state && this.state.turniri && this.state.turniri.filter(x => x.sifra == sifra)[0];
        var turnirDbNaziv = turnir.dbNaziv;

        return <div className="turnir turnir-details">
            <div className="relative">
                <img className="full-wide tablet-hidden" src={turnir.bannerUrl} alt={turnir.naziv} />
                <img className="mobile-hidden" src={turnir.bannerUrl} alt={turnir.naziv} />
                <div className="transparent-background-transparent-white-vertical tablet-hidden img-maska"></div>

            </div>
            <div>
                <div className="padding-sides-medium-2">
                    <div className="margin-bottom-xsmall"></div>

                    {action === 'info' &&
                        <div>
                            <h1 className="v2">{turnir.naziv}</h1>
                            <span dangerouslySetInnerHTML={{ __html: turnir.opis }} ></span>
                            <div className="margin-bottom-small"><br /></div>

                            <div className="tablet-hidden break-page"></div>
                            <div className="mobile-hidden"><br /></div>
                        </div>
                    }
                </div>
                <h2 className="v3 padding-sides-medium-2" id="results">Rezultati</h2>
                <PokerTurnirPobjednici showLoadingFn={this.props.showLoadingFn} turnir={turnirDbNaziv} />
                <div className="tablet-hidden"><br /></div>

                {action === 'info' &&
                    <div className="tablet-hidden break-page"></div>
                }



                <div className="mobile-hidden"><br /></div>

            </div >
        </div >

    }
    renderTurniri() {
        var pathName = this.props.route.match.url;
        let firstDone = false;

        return <div><h1 className="margin-bottom mobile-hidden">Svi turniri</h1>
            <div className="padding-sides-medium-2">

                {!this.state.turniri && <div className='min-height-50'><br />Dohvaćanje turnira...</div>}

                {this.state.turniri && this.state.turniri.map((turnir) => (<div className="turnir as-block" key={turnir.sifra}>
                    {firstDone && <div className="tablet-hidden break-page"></div>}
                    {firstDone = true}
                    <div className="margin-bottom-xsmall"></div>
                    <NavLink key={turnir.sifra + 'rezultati-link'} to={pathName + '/' + turnir.sifra + '/info'}>
                        <h2 className="v2">{turnir.naziv}</h2>
                        <img src={turnir.bannerUrl} alt={turnir.naziv} />
                    </NavLink>
                    <div className="margin-bottom-xsmall"></div>
                    <span>{turnir.opisKratki}</span>
                    <div className="flex  margin-bottom-small margin-top-xsmall">
                        <NavLink className="flex-expand-1 btn medium fill dark-green " key={turnir.sifra + 'rezultati-link'} to={pathName + '/' + turnir.sifra + '/results'}
                                onClick={() => casino.utils.createPageGoogleTagManagerEvent('Turniri', turnir.dbNaziv + ' - Rezultati', 'poker')}><span>Rezultati</span></NavLink>
                        <div>&nbsp;&nbsp;</div>
                        <NavLink className="flex-expand-1 btn medium fill gray " key={turnir.sifra + 'info-link'} to={pathName + '/' + turnir.sifra + '/info'}
                                onClick={() => casino.utils.createPageGoogleTagManagerEvent('Turniri', turnir.dbNaziv, 'poker')}><span>Saznaj više</span></NavLink>
                    </div>
                    <div className="mobile-hidden"><br /></div>
                </div>))}

                <div className="tablet-hidden break-page"></div>                
            </div>
        </div>
    }
    render() {
        var pathName = this.props.route.match.url;
        return <div>
            <Switch>
                {/* turnir header */}
                <Route path={"/poker/tournaments/:turnir/:action?"} render={(route) =>
                (<div>
                    <Header key="header" {...this.state} {...this.props} detailsHeader="true" headerText={this.getBackHeaderText(route)} headerBackUrl={'/poker/tournaments'}></Header>
                </div>)} />
                {/* turniri header, default */}
                <Route render={(route) =>
                (<div>
                    <Header key="header" {...this.state} {...this.props} ></Header>
                </div>)} />
            </Switch>

            <div className="flex  margin-1p-on-tablet ">
                {/* meni lijevi za tablet */}
                <div className="account-menu mobile-hidden">
                    <div className="as-block">
                        <div className="sidebar-menu">
                            <span className="sidebar-menu--header">Popis turnira</span>
                            <NavLink key='svi-turniri' exact activeClassName="selected" className="sidebar-menu--link" to={pathName}><span>Svi turniri</span><span className='icon ico-eye'></span></NavLink>
                            {this.state && this.state.turniri && this.state.turniri.map(this.renderSideNavigationItem)}
                        </div>
                    </div>
                </div>
                <div id="page-wrapper" className="white flex-expand-1 no-padding-on-mobile border-on-tablet">
                    <div className="max-width-80">
                        <Switch>
                            {/* turnir header */}
                            <Route path={"/poker/tournaments/:turnir/:action?"}
                                render={(route) => this.renderTurnirDetails(route)} />
                            {/* turniri header, default */}
                            <Route render={this.renderTurniri} />
                        </Switch>
                    </div>
                </div>
            </div>
            <div className="poker-text-info">
                <div className="poker-container-wider turniri">
                    <section className="padding-sides-medium-2">
                        <div className="title-container">
                            <h1 className="v3">Poker turniri</h1>
                            <img src="content/images/poker/-e-icon_online_poker.png" alt="SuperSport Online Poker"></img>
                        </div>
                        <br />
                        <p>
                            SuperSport Poker organizira Poker turnire koji su jedna od najpopularnijih Poker natjecanja u kojima sudionici osvajaju novčane bonuse ovisno o završnoj poziciji na turniru.
                        </p>
                        <br />
                        <p>
                            SuperSport Poker organizira najveći broj različitih vrsta turnira kao što su Rebuy, Freezeout, Double Chance i besplatni Freeroll Poker turniri. Većina turnira ima garantirani nagradni fond što znači da ćete se moći natjecati za unaprijed određene minimalne nagrade bez obzira na broj sudionika na poker turniru.
                        </p>
                    </section>
                </div>
            </div>
            <ObavijestiPoker {...this.props}></ObavijestiPoker>
        </div>

    }
};
